import LockerType from 'src/models/locker/LockerType'
import LockerSize from 'src/models/locker/LockerSize'
import { LengthUnit } from 'src/models/locker/enums/LengthUnit'

export default class LockerTypeWithSize {
  lockerType: LockerType
  lockerSize?: LockerSize

  constructor(lockerType: LockerType, lockerSize?: LockerSize) {
    this.lockerType = lockerType
    this.lockerSize = lockerSize
  }
}

const LockerTypeWithSizeMatcher = (
  lockerTypes: Array<LockerType>,
  lockerSizes: Array<LockerSize>,
): Array<LockerTypeWithSize> => {
  return lockerTypes
    .map((lockerType: LockerType) => {
      const smallestMatchingLockerSize = lockerSizes
        ?.filter((lockerSize) => lockerSize.types.includes(lockerType.id))
        .sort(
          (a, b) =>
            a.dimensions.volume(LengthUnit.UNIT_MM) -
            b.dimensions.volume(LengthUnit.UNIT_MM),
        )[0]

      return new LockerTypeWithSize(lockerType, smallestMatchingLockerSize)
    })
    .sort((a, b) => {
      if (!a.lockerSize) return 1
      if (!b.lockerSize) return -1

      return (
        a.lockerSize.dimensions.volume(LengthUnit.UNIT_MM) -
        b.lockerSize.dimensions.volume(LengthUnit.UNIT_MM)
      )
    })
}

export { LockerTypeWithSizeMatcher }
